import * as Yup from 'yup'
import { NO_MACHINE_VALUE } from 'services/CardMachine'

const isCardPayment = paymentMethod => (
  ['credit_card', 'debit_card'].includes (paymentMethod?.value.codename)
)

// O Pix também pode ser recebido por maquininha, ou "sem maquininha" (direto na conta).
const isMachinePayment = paymentMethod => (
  isCardPayment (paymentMethod) || paymentMethod?.value.codename === 'pix'
)

// Bandeira e modalidade só valem com maquininha de verdade, não com "Sem maquininha".
const isMachineChosen = (paymentMethod, cardMachine) => (
  isMachinePayment (paymentMethod) && cardMachine?.value !== NO_MACHINE_VALUE
)

// Cartão de crédito/débito e Pix exigem a escolha da maquininha ("Maquininha sem registro" e, no
// Pix, "Sem maquininha" também contam); os demais métodos não têm esses campos.
const requiredWhen = (fields, condition, message) => Yup
  .object ()
  .nullable ()
  .when (fields, {
    is: condition,
    then: schema => schema.required (message)
  })

const paymentValidator = Yup.object ({
  payments: Yup.array ().of (Yup.object ().shape ({
    value: Yup.number (),

    description: Yup
      .string ()
      .max (128, 'A descrição deve ter até 128 caracteres'),

    paymentMethod: Yup
      .object ()
      .nullable ()
      .required ('Selecione o método de pagamento'),

    bankAccount: Yup
      .object ()
      .nullable (),

    cardMachine: requiredWhen ('paymentMethod', isMachinePayment, 'Selecione a maquininha'),

    // Pix não tem bandeira: a taxa é única na maquininha, sem depender dela.
    brand: requiredWhen (
      ['paymentMethod', 'cardMachine'],
      (paymentMethod, cardMachine) => isCardPayment (paymentMethod) && isMachineChosen (paymentMethod, cardMachine),
      'Selecione a bandeira'
    ),

    modality: requiredWhen (['paymentMethod', 'cardMachine'], isMachineChosen, 'Selecione a modalidade'),

    feePercent: Yup.number ().nullable (),
    feeValue: Yup.number ().nullable (),
    netValue: Yup.number ().nullable (),
    feeChargedToCustomer: Yup.boolean ().nullable (),

    installments: Yup.number ().nullable (),

    installmentValue: Yup
      .number ()
      .nullable ()
  }))
})

export default paymentValidator
